module.exports = __webpack_public_path__ + "static/media/magia_sombras.d9f2e88f.webp";